<template>
  <v-container fluid>
    <div id="content">

      <section class="d-flex">
        <BreadCrumb :items="$route.matched"></BreadCrumb>
      </section>

      <div class="">
        <h3 class="mx-2">商品と品目を選択してください</h3>
        <v-row no-gutters>
          <v-col cols="6" class="pa-2">
            <v-combobox
              ref="products"
              label="商品"
              v-model="selectProduct"
              :items="productItems"
              append-icon="fas fa-list-ol"
              @click.stop="openSelected('products')"
              @change="productChange"
              readonly outlined hide-details="auto">
            </v-combobox>
          </v-col>
          <v-col cols="6" class="pa-2" v-if="selectProduct">
            <v-combobox
              ref="models"
              label="品目"
              v-model="selectModel"
              :items="modelItems"
              append-icon="fas fa-list-ol"
              @click.stop="openSelected('models')"
              @change="modelChange"
              readonly outlined hide-details="auto">
            </v-combobox>
          </v-col>
        </v-row>
      </div>

      <div v-if="selectModel">
        <h3 class="mt-5">入出庫履歴</h3>
        <section class="d-flex">
          <div class="stock">
            <span class="label">現在の在庫数</span>
            <span class="num">{{ totalValue }}</span>
          </div>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click.stop="dialog = true" depressed>入出庫を登録</v-btn>
        </section>
        <section>
          <v-data-table
            :headers="tableHeaders"
            :items="desserts"
            :sort-by="['createdAt']"
            :sort-desc="[true]"
            :loading="loading">
            <template v-slot:item.createdAt="{ item }">
              {{ getDateTime(item.createdAt) }}
            </template>
            <template v-slot:item.userID="{ item }">
              {{ item.userID ? users[item.userID] : 'Web注文' }}
            </template>
            <template v-slot:item.customerID="{ item }">
              {{ customers[item.customerID] }}
            </template>
            <template v-slot:item.quantity="{ item }">
              <template v-if="item.quantity >= 0">
                <v-chip color="blue" label dark>
                  {{ item.quantity }}
                  <v-icon right>fas fa-angle-double-right</v-icon>
                </v-chip>
              </template>
              <template v-else>
                <v-chip color="red" label dark>
                  {{ -item.quantity }}
                  <v-icon right>fas fa-angle-double-left</v-icon>
                </v-chip>
              </template>
            </template>
          </v-data-table>
        </section>
      </div>

      <!-- 編集ダイアログ -->
      <v-dialog v-model="dialog" max-width="800px" persistent>
        <v-card>
          <v-card-title class="dialog-header">
            <span class="title font-weight-light">入出庫</span>
          </v-card-title>
          <v-card-text>
            <v-form v-model="valid">
              <v-row no-gutters>
                <v-col cols="6" class="pa-2">
                  <p class="label">入出庫</p>
                  <toggle-button
                    v-model="editedItem.type"
                    :sync="true"
                    :labels="{checked: '入庫', unchecked: '出庫'}"
                    :color="{checked: '#0277bd', unchecked: '#eb4d4d'}"
                    :width="70" :height="30" :font-size="14" />
                </v-col>
                <v-col cols="6" class="pa-2">
                  <v-text-field
                    ref="quantity"
                    label="個数"
                    type="number"
                    v-model="editedItem.quantity"
                    :rules="[rules.required, rules.integer, rules.min0]"
                    class="required"
                    outlined hide-details="auto">
                  </v-text-field>
                </v-col>
              </v-row>
            </v-form>
          </v-card-text>
          <v-card-actions class="dialog-footer">
            <v-spacer></v-spacer>
            <v-btn color="primary" @click.stop="save" :loading="saving" :disabled="!valid" depressed>
              <v-icon left>fas fa-save</v-icon>登録
            </v-btn>
            <v-btn @click="dialog = false" depressed>
              <v-icon left>fas fa-times</v-icon>閉じる
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

    </div>
  </v-container>
</template>

<script>
import { API, graphqlOperation } from 'aws-amplify'
import { createStock, updateModel } from '../graphql/mutations'
import { listProducts, listStocks, listUsers, listCustomers } from '../graphql/queries'
import { onCreateStock } from '../graphql/subscriptions'
import moment from 'moment'

export default {
  data() {
    return {
      search: '',
      loading: true,
      tableHeaders: [
        { text: '日時', align: 'start', value: 'createdAt', sortable: false },
        { text: '担当者', align: 'start', value: 'userID', sortable: false },
        { text: '客先', align: 'start', value: 'customerID', sortable: false },
        { text: '増減', align: 'start', value: 'quantity', sortable: false },
        { text: '在庫数', align: 'start', value: 'total', sortable: false },
      ],
      dialog: false,
      valid: false,
      saving: false,
      desserts: [],
      products: [],
      models: [],
      users: {},
      customers: {},
      selectProduct: null,
      selectModel: null,
      editedItem: {
        type: true,
      },
    }
  },
  prop: {},
  mounted: async function() {
    //ユーザー query
    await this.getUsers()
    //客先 query
    await this.getCustomers()
    //商品 query
    await this.getProducts()
    //作成時 subscription
    await API.graphql(graphqlOperation(onCreateStock)).subscribe({
      next: (e) => {
        const data = e.value.data.onCreateStock
        if (data.modelID == this.selectModel.value) {
          this.desserts.push(data)
        }
      }
    })
    this.loading = false
  },
  beforeDestroy() {},
  created() {
    if (!this.isAllowed(this.$route.name)) this.$router.push('/')
  },
  computed: {
    productItems() {
      const map = []
      for (const item of this.products) {
        map.push({
          value: item.id,
          text: (item.category ? item.category + ' - ' : '') + item.name,
        })
      }
      return map
    },
    modelItems() {
      const map = []
      for (const item of this.models) {
        if (item.inventory) {
          const spec = []
          //品番
          if (item.code) spec.push(item.code)
          //サイズ
          if (item.size) spec.push(item.size)
          //色
          if (item.color) spec.push(item.color)
          //材質
          if (item.material) spec.push(item.material)
          map.push({
            value: item.id,
            text: spec.length > 0 ? item.name + '(' + spec.join('/') + ')' : item.name,
          })
        }
      }
      return map
    },
    //現在の在庫数を返す
    totalValue() {
      const map = [...this.desserts]
      map.sort(function(a,b) {
        if (a.createdAt > b.createdAt) return -1
        if (a.createdAt < b.createdAt) return 1
        return 0
      })
      return map.length > 0 ? map[0].total : 0
    },
  },
  watch: {
    dialog(val) {
      val || this.close()
    },
  },
  methods: {
    //初期化
    async init() {

    },
    //保存
    async save() {
      try {
        this.saving = true
        //登録する数量
        const quantity = this.editedItem.type ? parseInt(this.editedItem.quantity) : parseInt(-this.editedItem.quantity)
        //現在の在庫数
        let total = this.totalValue
        //登録する
        const data = {
          userID: this.getMyself().id,
          modelID: this.selectModel.value,
          quantity: quantity,
          total: total + quantity,
          createdAt: moment().format('YYYY-MM-DDTHH:mm:ss.SSSZ'),
        }
        await API.graphql(graphqlOperation(createStock, {input: data}))
        //品目の在庫数を変更
        await API.graphql(graphqlOperation(updateModel, {
          input: {
            id: this.selectModel.value,
            remain: total + quantity,
          }
        }))
        //ログ出力
        this.log({ type: this.$route.name, text: '[' + this.selectModel.text + '] の在庫数を変更' })

        this.dialog = false
      } catch (e) {
        this.myAlert(e)
        this.saving = false
      }
    },
    //ダイアログclose
    close() {
      this.saving = false
      this.dialog = false
      setTimeout(() => {
        this.resetForm()
        this.editedIndex = -1
      }, 300)
    },
    //フォームreset
    resetForm() {
      this.editedItem.type = true
      this.$refs['quantity'].reset()
    },
    //ユーザーの取得
    async getUsers(nextToken = null) {
      const query = await API.graphql(graphqlOperation(listUsers, { limit: 500, nextToken: nextToken }))
      for (const data of query.data.listUsers.items) {
        this.users[data.id] = data.last + data.first
      }
      if (query.data.listUsers.nextToken) this.getUsers(query.data.listUsers.nextToken)
    },
    //客先の取得
    async getCustomers(nextToken = null) {
      const query = await API.graphql(graphqlOperation(listCustomers, { limit: 500, nextToken: nextToken }))
      for (const data of query.data.listCustomers.items) {
        this.customers[data.id] = data.name
      }
      if (query.data.listCustomers.nextToken) this.getCustomers(query.data.listCustomers.nextToken)
    },
    //商品リストの取得
    async getProducts(nextToken = null) {
      const query = await API.graphql(graphqlOperation(listProducts, { limit: 500, nextToken: nextToken }))
      for (const row of query.data.listProducts.items) {
        this.products.push(row)
      }
      if (query.data.listProducts.nextToken) this.getProducts(query.data.listProducts.nextToken)
    },
    //入出庫履歴の取得
    async getStocks(modelID, nextToken = null) {
      const query = await API.graphql(graphqlOperation(listStocks, {
        filter: {
          modelID: { eq: modelID }
        },
        limit: 500,
        nextToken: nextToken
      }))
      for (const row of query.data.listStocks.items) {
        this.desserts.push(row)
      }
      if (query.data.listStocks.nextToken) this.getStocks(modelID, query.data.listStocks.nextToken)
    },
    //商品の選択
    productChange(item) {
      this.selectModel = null
      this.models = this.products.find(e => e.id === item.value).models.items
      this.models.sort(function(a,b) {
        if (a.createdAt < b.createdAt) return -1
        if (a.createdAt > b.createdAt) return 1
        return 0
      })
    },
    //品目の選択
    async modelChange(item) {
      this.desserts = []
      await this.getStocks(item.value)
    },
  },
  components: {

  },
}
</script>

<style lang='scss' scoped>
.stock {
  .label {
    font-size: 12px;
    line-height: 36px;
  }
  .num {
    line-height: 36px;
    font-size: 36px;
    font-weight: bold;
    margin-left: 10px;
    padding: 0 10px;
    border-bottom: 3px solid #0277bd;
  }
}
</style>
